/* Попап */

import { checkHotline } from "./Hotline";

if ($('.js-popup-btn').length) {
    generateImgPopup();

    const $allpopups = $('.js-popup'); // собираем попапы тут, т.к. generateImgPopup их еще добавит динамически

    addEvents($allpopups);
}

export function addEvents($popups) {
    /* открытие попапа — показываем нужный и блокируем скролл страницы */
    $('.js-popup-btn').on('click', function (e) {
        const currentPopup = $(this).data('type');

        App.lockScroll.lock();
        $(`.js-popup[data-type="${currentPopup}"]`).addClass('_open');

        if (currentPopup === 'hotline') {
            checkHotline();
        }

        e.preventDefault();
    });

    /* закрытие попапа */
    App.D.on('click', '.js-popup-close', function (e) {
        closePopup();

        e.preventDefault();
    });

    /* закрываем попап по клику вне контента попапа */
    App.D.on('click', '.js-popup', function (e) {
        // если экран успешной отправки формы, то при клике вне его, иначе при клике вне контента всего попапа
        const popupInner = App.H.is('._form-success') ? $popups.filter('._open').find('.form__success') : $popups.filter('._open').find('.popup-inner');

        if (!popupInner.is(e.target) && popupInner.has(e.target).length === 0) {
            closePopup();
        }
    });

    App.D.on('keyup', function (e) {
        if (e.keyCode === 27) {
            closePopup();
        }
    });
}

function closePopup() {
    const $currPopup = $('.js-popup._open');

    $currPopup.removeClass('_open');
    App.lockScroll.unlock();

    if ($currPopup.find('.video-frame').length) {
        setTimeout(function () {
            $currPopup.find('iframe').remove();
            $currPopup.find('.video').removeClass('_active');
        }, 400);
    }

    if ($currPopup.find('.js-hotline-email').length) {
        $('.js-hotline-email').find('.js-input').attr('data-required', true);
        $('.js-hotline-email-check').prop('checked', false);
    }

    setTimeout(function () {
        App.H.removeClass('_form-success _form-message');
    }, 300);
}

function generateImgPopup() {
    $('.js-popup-btn').filter('[data-img]').each(function (index, el) {
        const $currLink = $(el);
        const currBigImg = $currLink.attr('href');
        const currPopup = `
            <div class="popup photo-popup js-popup" data-type="img-popup-${index}">
                <div class="popup-inner">
                    <div class="popup-inner__img">
                        <a href="#" class="popup-close js-popup-close"></a>
                        <img src="${currBigImg}">
                    </div>
                </div>
            </div>
        `;

        $currLink.attr('data-type', `img-popup-${index}`);

        App.B.append(`${currPopup}`);
    });
}


// WEBPACK FOOTER //
// ./_src/js/Popup.js